module.exports = __webpack_public_path__ + "static/media/winners_amber.653bc81b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/winners_amber.svg
// module id = 1106
// module chunks = 2